import baseAPI from '@/api/base';
import {
  EditMember,
  GetMember,
  RegisterMember,
} from '@/dtos/member.dto';
import {
  DELETE_MEMBER_URL,
  EDIT_MEMBER_URL,
  GET_MEMBER_URL,
  REGISTER_MEMBER_URL,
  TOGGLE_MEMBER_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Member {
  static getMembers = async (
    getMember: GetMember
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MEMBER_URL, {
      params: getMember,
    });
    console.log('response', response);
    return response;
  };

  static registerMember = async (
    registerMember: RegisterMember
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_MEMBER_URL,
      {
        ...registerMember,
      }
    );
    console.log('response', response);
    return response;
  };

  static editMember = async (
    editMember: EditMember
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_MEMBER_URL,
      {
        ...editMember,
      }
    );
    return response;
  };

  static toggleMemberIsActive = async (
    editMember: EditMember
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MEMBER_IS_ACTIVE_URL,
      {
        ...editMember,
      }
    );
    return response;
  };

  static deleteMember = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MEMBER_URL}/${id}`
    );
    return response;
  };
}

export default Member;
